import React, { useContext } from 'react'

import ReactChangelog, {
  ThemeType,
  ChangelogData,
  ChangelogItem,
} from '@eltoro-ui/eltoro-release-notes'
import { AppContext, ThemeContext } from 'Contexts'
import { releaseNotes } from './release_note'

const removeAdminEntries = (data: ChangelogData): ChangelogData => {
  const filterAdminEntries = (
    entries: string[] | ChangelogItem[] | undefined,
  ): string[] | ChangelogItem[] | undefined => {
    if (!entries) return entries

    // If it's a string array, return as is
    if (entries.length === 0) return entries
    if (typeof entries[0] === 'string') return entries as string[]

    // If it's a ChangelogItem array, filter out admin entries
    return (entries as ChangelogItem[]).filter((entry) => !entry.admin)
  }

  return {
    ...data,
    list: data.list.map((release) => ({
      ...release,
      fixes: filterAdminEntries(release.fixes) as
        | string[]
        | ChangelogItem[]
        | undefined,
      features: filterAdminEntries(release.features) as
        | string[]
        | ChangelogItem[]
        | undefined,
      improvements: filterAdminEntries(release.improvements) as
        | string[]
        | ChangelogItem[]
        | undefined,
    })),
  }
}

export const ReleaseNotePage = () => {
  const { name } = useContext(ThemeContext)
  const { isAdmin } = useContext(AppContext)

  return (
    <div className="h-full w-full overflow-hidden">
      <ReactChangelog
        data={isAdmin ? releaseNotes : removeAdminEntries(releaseNotes)}
        theme={name === 'default' ? undefined : (name as ThemeType)}
        admin={isAdmin}
      />
    </div>
  )
}
